import { CreditCardService } from '@wix/cashier-core/dist/src/services/CreditCard';
import { appInstanceResolver } from '../appInstanceResolver';

const createCCService = () =>
  new CreditCardService({
    appInstance: appInstanceResolver.appInstance,
    revalidateAppInstance: appInstanceResolver.revalidate,
  });

export const cardAPI = {
  fetchCards: () => createCCService().fetchCreditCards({ fullInfo: true }),
  deleteCard: (cardId: string) => createCCService().deleteCreditCard(cardId),
  makeCardPrimary: (cardId: string) => createCCService().makeCreditCardPrimary(cardId),
};
